module.exports = __webpack_public_path__ + "static/rcc-581-study-characteristics-desktop-06a2fe56144c00a7e8012274e401a200.png";